import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class ScheduleGradeAircraftLineDays extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      sgasd_id: this.props.day.sgasd_id,
      type: this.props.day.type,
      type_original: this.props.day.type,
      date: this.props.day.date,
      date: this.props.date,
      types_list: this.props.types_list,
      edit_mode: this.props.edit_mode,
      sgas_id: this.props.sgas_id,
      show_select: 0,
    };

    this.locale = getLocale();

    this.toggleSelect = this.toggleSelect.bind(this);
    this.toggleSelectProps = this.toggleSelectProps.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.changeType = this.changeType.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(newProps.toggled === 1) {
      this.toggleSelectProps();
    }
    if((this.state.loaded === 0 && typeof newProps.day.type !== 'undefined' && typeof newProps.day.sgasd_id !== 'undefined' &&  Array.isArray(newProps.types_list)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      var new_type_value = newProps.types_list.find(({ label }) => label === newProps.day.type);
      if(typeof new_type_value === 'undefined') new_type_value = {value: null};
      this.setState({
        sgasd_id: newProps.day.sgasd_id,
        sgas_id: newProps.sgas_id,
        date: newProps.date,
        type: newProps.day.type,
        type_original: new_type_value.value,
        types_list: newProps.types_list,
        loaded: 1,
      });
    }
    this.setState({edit_mode: newProps.edit_mode});
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event !== null) {
      change[name] = event.value;
      this.setState(change);
      if (this.state.show_select === 1 && event !== null) {
        this.changeType(event.value);
      }
    }
  }
  handleSelectKeyUp(name, event) {
    var change = {};
    if(event !== null) {
      if(event.keyCode === 37) {
        this.props.cloneDay('left', this.state.type, this.state.date, this.state.sgas_id)
      }
      if(event.keyCode === 39) {
        this.props.cloneDay('right', this.state.type, this.state.date, this.state.sgas_id)
      }
    }
  }

  // exibe o select
  toggleSelect() {
    if(this.state.edit_mode) {
      this.setState({show_select: 1});
      this.props.toggleAllSelect();
    }
  }
  // exibe todos os select
  toggleSelectProps() {
    this.setState({show_select: 1});
  }

  // Fecha select quando pressionada a tecla esc
  escFunction(event){
    if(event.keyCode === 27) {
      this.setState({show_select: 0});
    }
  }

  // action para trocar o type do SGASD
  changeType (type) {
    var self = this;
    var type_original = type;
    var new_type_value = self.state.types_list.find(({ value }) => value === type);
    if(typeof new_type_value === 'undefined') new_type_value = {label: null};
    self.setState({show_select: 0, type: new_type_value.label, type_original: type_original});
    self.props.changeDateType(this.state.sgas_id, this.state.date, new_type_value.label);
  }


  render() {
    var self = this;
    var style = self.props.initials_colors[this.state.type];
    return (
  <td className={"text-center schedule-days-editable table-schedule-main-day-" + self.props.zoom_level} onClick={this.toggleSelect} style={style} onKeyUp={this.handleSelectKeyUp.bind(this, 'type')}>
    <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />

    {(self.state.show_select === 1 && self.state.edit_mode) ?
      <Select
        className={"form-field-name select-schedule-main-day-" + self.props.zoom_level}
        name="type"
        value={this.state.type_original}
        searchable={true}
        placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.placeholder.Indisponivel}
        onChange={this.handleSelectChange.bind(this, 'type')}
        options={this.state.types_list}
        id={this.state.sgasd_id}
      />
    :
      <div>{self.state.type}</div>
    }
  </td>
    );
  }
}

export default ScheduleGradeAircraftLineDays;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAircraftLineDays.js